import { Fragment, HTMLAttributes, ReactElement } from 'react';
import { joinClassNames } from '../../utils';
import styles from './DetailsCard.module.scss';

export type DetailsCardContent = {
  label: string;
  description: ReactElement;
};

export type DetailsCardProps = HTMLAttributes<HTMLDListElement> & {
  contents: DetailsCardContent[];
};

export const DetailsCard = ({ contents, className, ...props }: DetailsCardProps) => {
  const classNames = joinClassNames(styles.detailsCard, className);

  const mapContentToRow = ({ label, description }: DetailsCardContent) => (
    <Fragment key={label}>
      <dt className={styles.label}>{label}</dt>
      <dd className={styles.content}>{description}</dd>
    </Fragment>
  );

  return (
    <dl className={classNames} {...props}>
      {contents.map(mapContentToRow)}
    </dl>
  );
};

DetailsCard.displayName = 'DetailsCard';
